export default __webpack_public_path__ + "static/media/warning.e01ef508.svg";